<template>
  <div>
    <div
      class="d-flex align-items-center rounded container-border"
      style="font-size: 13px;"
    >
      <div
        v-for="(option, optionIndex) in options"
        :key="option.value"
        @click="selectOption(option.value)"
        class="d-flex align-items-center justify-content-center hover-pointer px-2 rounded"
        :style="
          `padding-top: 7px;padding-bottom: 7px; width: ${
            option.width ? option.width : '105'
          }px;`
        "
        :class="
          option.value == value
            ? 'bg-white container-border border-bottom-0 border-top-0' +
              (optionIndex == options.length - 1 ? ' border-right-0' : '') +
              (optionIndex == 0 ? ' border-left-0' : '')
            : 'option-deselected'
        "
      >
        <i
          class=""
          :class="option.icon + (option.value == value ? ' text-primary' : '')"
        ></i
        ><span class="ml-2">{{ option.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViewSwitch",
  props: ["options", "value"],
  methods: {
    selectOption(newValue) {
      this.$emit("input", newValue);
    }
  }
};
</script>

<style scoped>
.container-border {
  border: 1px solid #e3e6ea;
}
.option-deselected {
  color: #999898;
}
</style>
